import { getThreadMessages } from './get-thread-messages';
export var getLastThreadMessage = function (state) {
    return function (threadId) {
        var messages = getThreadMessages(state)(threadId);
        return messages[messages.length - 1];
    };
};
